import { api, apiUrl } from "../../../shared/services/service";
import type {
  VesselSearcherOptionField,
  VesselSearcherOptionContext,
  VesselSearcherRequest,
  VesselSearcherResponse,
} from "../models/vessel-searcher.models";

const toVesselSearcherFilterParams = (request: VesselSearcherOptionContext) => ({
  ...(request.imo.trim() ? { imo: request.imo.trim() } : {}),
  ...(request.vesselName.trim() ? { vesselName: request.vesselName.trim() } : {}),
  ...(request.useScrubber !== "all" ? { useScrubber: request.useScrubber } : {}),
  ...(request.hasVoyageInImos !== "all" ? { hasVoyageInImos: request.hasVoyageInImos } : {}),
  ...(request.activeRangeFilters.includes("buildDate") && request.buildDateFrom ? { buildDateFrom: request.buildDateFrom } : {}),
  ...(request.activeRangeFilters.includes("buildDate") && request.buildDateTo ? { buildDateTo: request.buildDateTo } : {}),
  ...(request.activeRangeFilters.includes("dwt") && request.dwt.min !== "" ? { dwtMin: request.dwt.min } : {}),
  ...(request.activeRangeFilters.includes("dwt") && request.dwt.max !== "" ? { dwtMax: request.dwt.max } : {}),
  ...(request.activeRangeFilters.includes("lbp") && request.lbp.min !== "" ? { lbpMin: request.lbp.min } : {}),
  ...(request.activeRangeFilters.includes("lbp") && request.lbp.max !== "" ? { lbpMax: request.lbp.max } : {}),
  ...(request.activeRangeFilters.includes("draft") && request.draft.min !== "" ? { draftMin: request.draft.min } : {}),
  ...(request.activeRangeFilters.includes("draft") && request.draft.max !== "" ? { draftMax: request.draft.max } : {}),
  ...(request.activeRangeFilters.includes("depth") && request.depth.min !== "" ? { depthMin: request.depth.min } : {}),
  ...(request.activeRangeFilters.includes("depth") && request.depth.max !== "" ? { depthMax: request.depth.max } : {}),
  ...(request.activeRangeFilters.includes("breadth") && request.breadth.min !== "" ? { breadthMin: request.breadth.min } : {}),
  ...(request.activeRangeFilters.includes("breadth") && request.breadth.max !== "" ? { breadthMax: request.breadth.max } : {}),
  ...(request.engineTypes.length > 0 ? { engineTypes: JSON.stringify(request.engineTypes) } : {}),
  ...(request.designs.length > 0 ? { designs: JSON.stringify(request.designs) } : {}),
  ...(request.yards.length > 0 ? { yards: JSON.stringify(request.yards) } : {}),
  ...(request.countries.length > 0 ? { countries: JSON.stringify(request.countries) } : {}),
});

const toVesselSearcherParams = (request: VesselSearcherRequest) => ({
  ...toVesselSearcherFilterParams(request),
  sortBy: request.sortBy,
  sortDirection: request.sortDirection,
  offset: request.offset,
  limit: request.limit,
});

export const getVesselSearcherVessels = async (
  request: VesselSearcherRequest,
  signal: AbortSignal,
): Promise<VesselSearcherResponse> => {
  const response = await api.get<VesselSearcherResponse>(`${apiUrl}/pbi/vessel-searcher`, {
    params: toVesselSearcherParams(request),
    signal,
  });

  return response.data;
};

export const getVesselSearcherOptions = async (
  field: VesselSearcherOptionField,
  search: string,
  context: VesselSearcherOptionContext,
  signal: AbortSignal,
): Promise<string[]> => {
  const response = await api.get<string[]>(`${apiUrl}/pbi/vessel-searcher/options`, {
    params: {
      ...toVesselSearcherFilterParams(context),
      field,
      ...(search.trim() ? { search: search.trim() } : {}),
      limit: 50,
    },
    signal,
  });

  return response.data;
};
